// extracted by mini-css-extract-plugin
module.exports = {"mb20":"SSNIT_mb20__1K-tn"};